import React from 'react';
import { DateQuestion } from '../date/date-question';
import { DefaultQuestion, DefaultQuestionProps } from '../default/default';
import { ChoiceQuestion } from '../choice/choice-question';
import { BooleanQuestion } from '../boolean/boolean-question';
import { ServiceQuestion } from '../service/service-question';
import { PerformerQuestion } from '../performer/performer';

interface QuestionFactoryProps extends DefaultQuestionProps {}
export const QuestionInputFactory = ({
	question,
	answer,
	answerQuestion,
}: QuestionFactoryProps) => {
	const getQuestionComponent = () => {
		switch (question.type) {
			case 'date':
				return DateQuestion;
			case 'choice':
				return ChoiceQuestion;
			case 'performer':
				return PerformerQuestion;
			case 'boolean':
				return BooleanQuestion;
			case 'service':
				return ServiceQuestion;
			default:
				return DefaultQuestion;
		}
	};

	const Question = getQuestionComponent();

	return (
		<Question
			question={question}
			answer={answer}
			answerQuestion={answerQuestion}
		/>
	);
};
